import {useCallback, useEffect, useState} from 'react'

import {Combobox, Popover, useCombobox} from '@mantine/core'
import {debounce} from 'lodash'
import {useTranslation} from 'react-i18next'

import Icon from '../../icon'

const DropDownText = ({children, onChange, value, searchable = true, top}) => {
  const {t} = useTranslation()
  const [search, setSearch] = useState(value || '')
  const [selectedItem, setSelectedItem] = useState(value)
  const [opened, setOpened] = useState(false)

  const combobox = useCombobox({
    onDropdownClose: () => {
      combobox.resetSelectedOption()
      combobox.focusTarget()
    },
    onDropdownOpen: () => {
      searchable && combobox.focusSearchInput()
    }
  })

  useEffect(() => {
    if (selectedItem !== '') {
      onChange(selectedItem)
    }
  }, [selectedItem])

  useEffect(() => {
    setSelectedItem(value)
  }, [value])

  const handleKeyDown = event => {
    if (search !== '' && event.key === 'Enter') {
      onChange(search)
      setOpened(false)
    }
  }

  const debouncedSetSearch = useCallback(
    debounce(value => {
      onChange(value)
    }, 600),
    []
  )

  const handleChange = event => {
    setSearch(event.currentTarget.value)
    debouncedSetSearch(event.currentTarget.value)
  }

  return (
    <Popover
      opened={opened}
      onChange={setOpened}
      position="bottom-start"
      offset={top || 5}
      width="auto"
      withinPortal={true}>
      <Popover.Target>
        <div onClick={() => setOpened(prev => !prev)}>{children}</div>
      </Popover.Target>

      <Popover.Dropdown style={{padding: 0}}>
        <Combobox
          store={combobox}
          onOptionSubmit={val => {
            setSelectedItem(val)
            setOpened(false)
          }}>
          <Combobox.Search
            value={search}
            onKeyDown={e => handleKeyDown(e)}
            onChange={handleChange}
            placeholder={`${t('SEARCH')}...`}
            rightSectionPointerEvents={search === '' ? 'none' : 'all'}
            rightSection={
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  marginRight: 24
                }}>
                {search !== '' ? (
                  <div
                    onMouseDown={event => event.preventDefault()}
                    onClick={() => {
                      setSearch('')
                      onChange('')
                    }}
                    aria-label="Clear value">
                    <Icon
                      className="comboBox-close-icon"
                      icon="closeIcon"
                      size={[18, 18]}
                    />
                  </div>
                ) : (
                  <Icon icon="searchIcon" size={[15, 15]} />
                )}
              </div>
            }
          />
        </Combobox>
      </Popover.Dropdown>
    </Popover>
  )
}

export default DropDownText
